import React, { useEffect, useMemo, useRef, useState } from 'react';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Include/Footer';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../Include/Loader';
import { Pagination, Search } from '../../Table';
import DropDown from '../../../../Components/DropDown';
import toast from 'react-hot-toast';
import CutPieceDrawer from './components/CutPieceDrawer';
import { getLotList } from '../../../../Store/Store/Transformation/lot/getLotList';
import { MultiSelect } from "primereact/multiselect";
import { getLotDropdown } from '../../../../Store/Store/Transformation/lot/getLotDropdown';
import { getTransactionDropdown } from '../../../../Store/Store/Transformation/transaction/getTransactionDropdown';
import { getItemDropdown } from '../../../../Store/Store/Transformation/items/getItemDropdown';
import { Collapse } from 'react-bootstrap';
import { lotStatus } from '../../../../helper/StatusFile';

const MaterialCutList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [selectedItem, setSelectedItem] = useState(null);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    const [showFilters, setShowFilters] = useState(false);

    const [filters, setFilters] = useState({
        lot: [],
        transaction: [],
        item: [],
    });

    useEffect(() => {
        if (localStorage.getItem('PAY_USER_TOKEN') === null) {
            navigate("/user/login");
        } else if (localStorage.getItem('VI_PRO') !== "Main Store") {
            toast.error('Access Denied. You do not have permission to view this product. Please contact your administrator for assistance.');
            navigate("/user/login");
        }
    }, [navigate]);

    useEffect(() => {
        const payload = {
            itemIds: filters.item,
            lotIds: filters.lot,
            transIds: filters.transaction,
            page: currentPage,
            limit: limit,
        }
        dispatch(getLotList(payload))
    }, [dispatch, filters, currentPage, limit]);

    useEffect(() => {
        dispatch(getLotDropdown())
        dispatch(getTransactionDropdown())
        dispatch(getItemDropdown())
    }, [dispatch])

    const { user, loading } = useSelector((state) => state?.getLotList);
    const lotDropdown = useSelector((state) => state?.getLotDropdown?.user?.data);
    const transactionDropdown = useSelector((state) => state?.getTransactionDropdown?.user?.data);
    const itemDropdown = useSelector((state) => state?.getItemDropdown?.user?.data);

    const result = user?.data?.result || [];
    const pagination = user?.data?.pagination || {};
    const totalItems = pagination?.total || 0;
    const backendCurrentPage = pagination?.currentPage || 1;
    const totalPages = pagination?.totalPages || 1;
    const backendLimit = pagination?.limit || limit;

    const lotOptions = lotDropdown?.map((lot) => ({
        label: lot.lot_no,
        value: lot._id
    }))

    const transactionOptions = transactionDropdown?.map((transaction) => ({
        label: transaction.voucher_no,
        value: transaction._id
    }))

    const itemOptions = itemDropdown?.map((item) => ({
        label: item.name,
        value: item._id
    }))

    const handleRefresh = () => {
        setSearch('');
        dispatch(getLotList());
        setFilters({
            lot: [],
            transaction: [],
            item: [],
        });
    };

    const handleOpenSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleRowClick = (item) => {
        setSelectedItem(item);
        setDrawerOpen(true);
    };

    const refreshList = () => {
        const payload = {
            itemIds: filters.item,
            lotIds: filters.lot,
            transIds: filters.transaction,
            page: currentPage,
            limit: limit,
        };
        dispatch(getLotList(payload));
    };

    return (
        <div className={`main-wrapper ${isSidebarOpen ? 'slide-nav' : ''}`}>
            <Header handleOpen={handleOpenSidebar} />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/main-store/user/dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                    <li className="breadcrumb-item active">Material Cut List</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="card card-table">
                        <div className="card-body">
                            <div className="page-table-header mb-3">
                                <div className="row align-items-center">
                                    <div className="col">
                                        <div className="doctor-table-blk">
                                            <h3 className="mb-0">Material Cut List</h3>
                                            <div className="doctor-search-blk">
                                                <div className="add-group">
                                                    <button
                                                        type='button'
                                                        onClick={handleRefresh}
                                                        className="btn btn-primary doctor-refresh ms-2"
                                                        data-toggle="tooltip"
                                                        title="Refresh"
                                                    >
                                                        <img src="/assets/img/icons/re-fresh.svg" alt="refresh" />
                                                    </button>
                                                    <button
                                                        type="button"
                                                        onClick={() => setShowFilters(!showFilters)}
                                                        className="btn btn-primary doctor-refresh ms-2"
                                                    >
                                                        <i className="fa fa-filter me-1"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-auto text-end mt-sm-0 mt-3">
                                        <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                                    </div>
                                </div>
                            </div>

                            <Collapse in={showFilters}>
                                <div>
                                    <div className="filter-panel card card-body px-2">
                                        <div className="row g-3">

                                            <div className="col-md-3 col-sm-6">
                                                <div className='input-block local-forms mt-3 mb-0 custom-select-wpr'>
                                                    <label className="form-label">Transaction</label>
                                                    <MultiSelect
                                                        value={filters.transaction}
                                                        options={transactionOptions}
                                                        onChange={(e) => {
                                                            setFilters({ ...filters, transaction: e.value });
                                                            setCurrentPage(1);
                                                        }}
                                                        placeholder="Select Transaction"
                                                        filter
                                                        className="w-100"
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3 col-sm-6">
                                                <div className='input-block local-forms mt-3 mb-0 custom-select-wpr'>
                                                    <label className="form-label">Item</label>
                                                    <MultiSelect
                                                        value={filters.item}
                                                        options={itemOptions}
                                                        onChange={(e) => {
                                                            setFilters({ ...filters, item: e.value });
                                                            setCurrentPage(1);
                                                        }}
                                                        placeholder="Select Item"
                                                        filter
                                                        className="w-100"
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-3 col-sm-6">
                                                <div className='input-block local-forms mt-3 mb-0 custom-select-wpr'>
                                                    <label className="form-label">Lot No</label>
                                                    <MultiSelect
                                                        value={filters.lot}
                                                        options={lotOptions}
                                                        onChange={(e) => {
                                                            setFilters({ ...filters, lot: e.value });
                                                            setCurrentPage(1);
                                                        }}
                                                        placeholder="Select Lot"
                                                        filter
                                                        className="w-100"
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </Collapse>
                            {!loading ? (

                                <div className="table-responsive">
                                    <table className="table material-table table-hover table-striped mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>#</th>
                                                <th>Lot No</th>
                                                <th>Trans No</th>
                                                <th>Item Name</th>
                                                <th>Original Qty</th>
                                                <th>Remaining Qty</th>
                                                <th>Used Area</th>
                                                <th>Remaining Area</th>
                                                <th>L/W/T • Wt • A</th>
                                                <th>Transform Type</th>
                                                <th>Stock Uom Type</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {result?.map((elem, i) => (
                                                <tr
                                                    key={elem?._id}
                                                    onClick={() => handleRowClick(elem)}
                                                    style={{ cursor: 'pointer' }}
                                                    className="material-row"
                                                >
                                                    <td>{(backendCurrentPage - 1) * backendLimit + i + 1}</td>
                                                    <td>
                                                        <strong>{elem?.lot_no || "-"}</strong>
                                                    </td>
                                                    <td>{elem?.trans_no || "-"}</td>
                                                    <td>{elem?.item_name || "-"}</td>
                                                    <td>{elem?.original_qty || "-"}</td>
                                                    <td>{elem?.remaining_qty || "-"}</td>
                                                    <td>{elem?.used_area || "-"}</td>
                                                    <td>{elem?.remaining_area || "-"}</td>
                                                    <td>{elem?.dimensions?.length || "0"}/{elem?.dimensions?.width || "0"}/{elem?.dimensions?.thickness || "0"} • {elem?.dimensions?.weight || "0"} • {elem?.dimensions?.area || "0"}</td>
                                                    <td>{elem?.transform_type || "-"}</td>
                                                    <td>{elem?.stock_uom_type || "-"}</td>
                                                    <td className='status-badge'>
                                                        <span className={lotStatus(elem?.status).class}>{lotStatus(elem?.status).name}</span>
                                                    </td>

                                                </tr>
                                            ))}

                                            {result?.length === 0 && (
                                                <tr>
                                                    <td colSpan="12">
                                                        <div className="text-center py-4">
                                                            <p className="mt-2 text-muted">No materials found</p>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            ) : (
                                <Loader />
                            )}
                            {/* Pagination */}
                            <div className="row align-center mt-3 mb-2">
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                        aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                </div>
                                <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                    <div className="dataTables_paginate paging_simple_numbers"
                                        id="DataTables_Table_0_paginate">
                                        <Pagination
                                            total={totalItems}
                                            itemsPerPage={backendLimit}
                                            currentPage={backendCurrentPage}
                                            onPageChange={(page) => setCurrentPage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <CutPieceDrawer
                    open={drawerOpen}
                    item={selectedItem}
                    onClose={() => setDrawerOpen(false)}
                    onSaved={refreshList}
                />

                <Footer />
            </div>

            {/* Custom Styles */}
            <style>{`
                .material-row:hover {
                    background-color: rgba(13, 110, 253, 0.05);
                }
                .btn-icon {
                    padding: 0.25rem 0.5rem;
                    border-radius: 0.375rem;
                }
                .badge {
                    font-weight: 500;
                    padding: 0.35em 0.65em;
                }
                .table > :not(caption) > * > * {
                    padding: 1rem 0.75rem;
                    vertical-align: middle;
                }
                .dropdown-item {
                    cursor: pointer;
                    font-size: 0.875rem;
                    padding: 0.5rem 1rem;
                }
                .dropdown-item i {
                    width: 1.25rem;
                }
                .dropdown-item:hover {
                    background-color: #f8f9fa;
                }
                .dropdown-item.text-danger:hover {
                    background-color: #dc3545;
                    color: white !important;
                }
                .dropdown-item.text-danger:hover i {
                    color: white;
                }
            `}</style>
        </div>
    );
};

export default MaterialCutList;